import { Material } from 'models/Material';
import { DiscountCode } from 'models/DiscountCode';

export const circularRevenueChartData = [
  {
    name: 'Trả hàng',
    value: 3491000,
    percentage: 100,
    color: 'var(--keyColor1)',
    // Lưu giá trị thô, định dạng khi hiển thị
    displayValue: '3,491,000 VNĐ',
  },
  {
    name: 'Bán hàng ',
    value: 800000,
    percentage: 20,
    color: 'var(--keyColor2)',
    displayValue: '800,000 VNĐ',
  },
  {
    name: 'Nhập hàng',
    value: 1491000,
    percentage: 20,
    color: 'var(--keyColor3)',
    displayValue: '1,491,000 VNĐ',
  },
];
export const circularRevenueMethodChartData = [
  {
    name: 'Tiền mặt',
    value: 800000,
    percentage: 20,
    color: 'var(--tealColor700)',
    displayValue: '800,000 VNĐ',
  },
  {
    name: 'Chuyển khoản',
    value: 1491000,
    percentage: 80,
    color: 'var(--cyanColor)',
    displayValue: '1,491,000 VNĐ',
  },
];
export const circularOrdersChartData = [
  {
    name: 'Trả hàng',
    value: 20,
    percentage: 50,
    color: 'var(--keyColor1)',
    displayValue: '20',
  },
  {
    name: 'Bán hàng ',
    value: 10,
    percentage: 25,
    color: 'var(--keyColor2)',
    displayValue: '10',
  },
  {
    name: 'Nhập hàng',
    value: 10,
    percentage: 25,
    color: 'var(--keyColor3)',
    displayValue: '10',
  },
];
// mock for ColumnChart
export const columnChartData = [
  {
    date: '01/08',
    returnOrders: 120,
    saleOrders: 340,
    purchaseOrders: 200,
  },
  {
    date: '02/08',
    returnOrders: 100,
    saleOrders: 320,
    purchaseOrders: 180,
  },
  {
    date: '03/08',
    returnOrders: 90,
    saleOrders: 300,
    purchaseOrders: 160,
  },
  {
    date: '04/08',
    returnOrders: 110,
    saleOrders: 310,
    purchaseOrders: 170,
  },
  {
    date: '05/08',
    returnOrders: 130,
    saleOrders: 350,
    purchaseOrders: 210,
  },
  {
    date: '06/08',
    returnOrders: 140,
    saleOrders: 360,
    purchaseOrders: 220,
  },
  {
    date: '07/08',
    returnOrders: 150,
    saleOrders: 370,
    purchaseOrders: 230,
  },
];

export const mockDataMaterial: Material[] = [
  {
    id: 'mat-001',
    code: 'OC-VIT-001',
    name: 'Ốc vít đầu nhỏ 3mm',
    costPrice: 500,
    salePrice: 1000,
    description: 'Ốc vít đầu nhỏ 3mm, chất liệu thép không gỉ, dùng cho các công trình nhẹ',
    unitId: 'unit-001',

    createdAt: new Date('2025-06-15T08:30:00Z'),
    updatedAt: new Date('2025-06-15T08:30:00Z'),
  },
  {
    id: 'mat-002',
    code: 'OC-VIT-002',
    name: 'Ốc vít đầu bằng 5mm',
    costPrice: 800,
    salePrice: 1500,
    description: 'Ốc vít đầu bằng 5mm, chất liệu thép carbon, dùng cho gỗ và kim loại mỏng',
    unitId: 'unit-001',

    createdAt: new Date('2025-06-15T09:15:00Z'),
    updatedAt: new Date('2025-06-15T09:15:00Z'),
  },
  {
    id: 'mat-003',
    code: 'DINH-001',
    name: 'Đinh thép 2cm',
    costPrice: 300,
    salePrice: 600,
    description: 'Đinh thép 2cm, dùng cho các công trình gỗ nhẹ',
    unitId: 'unit-002',

    createdAt: new Date('2025-06-16T10:30:00Z'),
    updatedAt: new Date('2025-06-16T10:30:00Z'),
  },
  {
    id: 'mat-004',
    code: 'DINH-002',
    name: 'Đinh thép 5cm',
    costPrice: 400,
    salePrice: 800,
    description: 'Đinh thép 5cm, dùng cho các công trình gỗ lớn',
    unitId: 'unit-002',

    createdAt: new Date('2025-06-16T11:45:00Z'),
    updatedAt: new Date('2025-06-16T11:45:00Z'),
  },
  {
    id: 'mat-005',
    code: 'XM-001',
    name: 'Xi măng PCB30',
    costPrice: 75000,
    salePrice: 90000,
    description: 'Xi măng Portland PCB30, bao 50kg, dùng cho các công trình xây dựng nhà ở',
    unitId: 'unit-003',

    createdAt: new Date('2025-06-17T07:30:00Z'),
    updatedAt: new Date('2025-06-17T07:30:00Z'),
  },
  {
    id: 'mat-006',
    code: 'CAT-001',
    name: 'Cát vàng xây dựng',
    costPrice: 250000,
    salePrice: 300000,
    description: 'Cát vàng xây dựng, dùng cho trộn vữa xây tô',
    unitId: 'unit-004',

    createdAt: new Date('2025-06-17T08:45:00Z'),
    updatedAt: new Date('2025-06-17T08:45:00Z'),
  },
  {
    id: 'mat-007',
    code: 'CAT-002',
    name: 'Cát đen san lấp',
    costPrice: 180000,
    salePrice: 220000,
    description: 'Cát đen dùng cho san lấp mặt bằng',
    unitId: 'unit-004',

    createdAt: new Date('2025-06-17T09:15:00Z'),
    updatedAt: new Date('2025-06-17T09:15:00Z'),
  },
  {
    id: 'mat-008',
    code: 'SON-001',
    name: 'Sơn trắng nội thất',
    costPrice: 420000,
    salePrice: 550000,
    description: 'Sơn trắng nội thất, thùng 18L, phủ được khoảng 80-100m²/thùng',
    unitId: 'unit-005',

    createdAt: new Date('2025-06-18T10:30:00Z'),
    updatedAt: new Date('2025-06-18T10:30:00Z'),
  },
  {
    id: 'mat-009',
    code: 'DAY-DIEN-001',
    name: 'Dây điện 1.5mm²',
    costPrice: 8500,
    salePrice: 12000,
    description: 'Dây điện đơn lõi 1.5mm², cuộn 100m',
    unitId: 'unit-006',

    createdAt: new Date('2025-06-19T11:00:00Z'),
    updatedAt: new Date('2025-06-19T11:00:00Z'),
  },
  {
    id: 'mat-010',
    code: 'DAY-DIEN-002',
    name: 'Dây điện 2.5mm²',
    costPrice: 13500,
    salePrice: 18000,
    description: 'Dây điện đơn lõi 2.5mm², cuộn 100m',
    unitId: 'unit-006',

    createdAt: new Date('2025-06-19T11:30:00Z'),
    updatedAt: new Date('2025-06-19T11:30:00Z'),
  },
  {
    id: 'mat-011',
    code: 'ONG-NUOC-001',
    name: 'Ống nước PVC 21mm',
    costPrice: 25000,
    salePrice: 32000,
    description: 'Ống nước PVC 21mm, dài 4m/cây',
    unitId: 'unit-007',

    createdAt: new Date('2025-06-20T08:15:00Z'),
    updatedAt: new Date('2025-06-20T08:15:00Z'),
  },
  {
    id: 'mat-012',
    code: 'ONG-NUOC-002',
    name: 'Ống nước PVC 27mm',
    costPrice: 32000,
    salePrice: 42000,
    description: 'Ống nước PVC 27mm, dài 4m/cây',
    unitId: 'unit-007',

    createdAt: new Date('2025-06-20T08:45:00Z'),
    updatedAt: new Date('2025-06-20T08:45:00Z'),
  },
  {
    id: 'mat-013',
    code: 'KHOA-CUA-001',
    name: 'Khóa cửa tay nắm',
    costPrice: 180000,
    salePrice: 250000,
    description: 'Khóa cửa tay nắm, chất liệu inox 304, kèm 3 chìa khóa',
    unitId: 'unit-008',

    createdAt: new Date('2025-06-21T09:30:00Z'),
    updatedAt: new Date('2025-06-21T09:30:00Z'),
  },
  {
    id: 'mat-014',
    code: 'BU-LONG-001',
    name: 'Bu lông M10x50',
    costPrice: 2500,
    salePrice: 4000,
    description: 'Bu lông M10x50, chất liệu thép mạ kẽm',
    unitId: 'unit-009',

    createdAt: new Date('2025-06-22T10:15:00Z'),
    updatedAt: new Date('2025-06-22T10:15:00Z'),
  },
  {
    id: 'mat-015',
    code: 'GACH-001',
    name: 'Gạch đỏ 4 lỗ',
    costPrice: 1200,
    salePrice: 1500,
    description: 'Gạch đỏ 4 lỗ tiêu chuẩn, kích thước 80x80x180mm',
    unitId: 'unit-010',

    createdAt: new Date('2025-06-23T07:45:00Z'),
    updatedAt: new Date('2025-06-23T07:45:00Z'),
  },
];

export const mockDataDiscountCode: DiscountCode[] = [
  {
    id: 'disc-001',
    code: 'DC8025001',
    discountCode: 'SUMMER2025',
    discountValue: 10,
    description: 'Mã giảm giá cho khách hàng mới trong mùa hè 2025',
    isActive: true,
  },
  {
    id: 'disc-002',
    code: 'DC8025002',
    discountCode: 'NEWCUST25',
    discountValue: 25,
    description: 'Giảm giá 25% cho khách hàng mới',
    isActive: true,
  },
  {
    id: 'disc-003',
    code: 'DC8025003',
    discountCode: 'WELCOME15',
    discountValue: 15,
    description: 'Chào mừng khách hàng với ưu đãi 15%',
    isActive: false,
  },
  {
    id: 'disc-004',
    code: 'DC8025004',
    discountCode: 'HOLIDAY30',
    discountValue: 30,
    description: 'Khuyến mãi dịp lễ giảm 30% tất cả sản phẩm',
    isActive: true,
  },
  {
    id: 'disc-005',
    code: 'DC8025005',
    discountCode: 'FLASH50',
    discountValue: 50,
    description: 'Giảm giá sốc 50% trong 24h',
    isActive: false,
  },
  {
    id: 'disc-006',
    code: 'DC8025006',
    discountCode: 'LOYAL20',
    discountValue: 20,
    description: 'Dành cho khách hàng thân thiết giảm 20%',
    isActive: true,
  },
  {
    id: 'disc-007',
    code: 'DC8025007',
    discountCode: 'BIRTHDAY10',
    discountValue: 10,
    description: 'Ưu đãi sinh nhật giảm 10%',
    isActive: true,
  },
  {
    id: 'disc-008',
    code: 'DC8025008',
    discountCode: 'RETURN15',
    discountValue: 15,
    description: 'Giảm 15% cho khách hàng quay lại sau 3 tháng',
    isActive: true,
  },
  {
    id: 'disc-009',
    code: 'DC8025009',
    discountCode: 'BULKBUY40',
    discountValue: 40,
    description: 'Giảm 40% cho đơn hàng trên 10 triệu',
    isActive: false,
  },
  {
    id: 'disc-010',
    code: 'DC8025010',
    discountCode: 'VIP25',
    discountValue: 25,
    description: 'Dành riêng cho khách hàng VIP',
    isActive: true,
  },
  {
    id: 'disc-011',
    code: 'DC8025011',
    discountCode: 'SPECIAL5',
    discountValue: 5,
    description: 'Ưu đãi đặc biệt giảm 5% cho tất cả khách hàng',
    isActive: true,
  },
  {
    id: 'disc-012',
    code: 'DC8025012',
    discountCode: 'APP20',
    discountValue: 20,
    description: 'Giảm 20% khi đặt hàng qua ứng dụng',
    isActive: true,
  },
  {
    id: 'disc-013',
    code: 'DC8025013',
    discountCode: 'WEEKEND10',
    discountValue: 10,
    description: 'Ưu đãi cuối tuần giảm 10%',
    isActive: false,
  },
  {
    id: 'disc-014',
    code: 'DC8025014',
    discountCode: 'FIRSTBUY30',
    discountValue: 30,
    description: 'Giảm 30% cho lần mua hàng đầu tiên',
    isActive: true,
  },
  {
    id: 'disc-015',
    code: 'DC8025015',
    discountCode: 'THANKYOU15',
    discountValue: 15,
    description: 'Cảm ơn khách hàng với ưu đãi 15%',
    isActive: true,
  },
];
